import React__default, { forwardRef } from 'react';
import { CheckCircleIcon } from './CheckCircleIcon.js';

const SuccessCheckCircleIcon = forwardRef((props, ref) => {
    return React__default.createElement(CheckCircleIcon, Object.assign({ htmlColor: "#ffffff", backgroundColor: "primary" }, props, { ref: ref }));
});

export { SuccessCheckCircleIcon };
//# sourceMappingURL=SuccessCheckCircleIcon.js.map
